import { TsDOM as q } from '@/scripts/core/TsDOM'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { TestimonialsSlider } from '@/scripts/theme/testimonials-slider'
import { UgcSlider } from '@/scripts/theme/ugc-slider'
import { ProductInfo } from '@/scripts/product/product-info'
import { ProductForm } from '@/scripts/product/product-form'
import { VariantSelects } from '@/scripts/theme/variant-selects'
import { StickyColumns } from '@/scripts/theme/sticky-columns'
import { TextCarousel } from '@/scripts/interactive-defer/text-carousel'
import { UcoastSelect } from '@/scripts/theme/ucoast-select'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { TabContent } from '@/scripts/theme/tab-content'

q.safeDefineElement(StickyHeader)
q.safeDefineElement(ProductSlider)
q.safeDefineElement(MultiProductSlider)
q.safeDefineElement(TestimonialsSlider)
q.safeDefineElement(TextCarousel)
q.safeDefineElement(UgcSlider)
q.safeDefineElement(ProductInfo)
q.safeDefineElement(ProductForm)
q.safeDefineElement(VariantSelects)
q.safeDefineElement(StickyColumns)
q.safeDefineElement(UcoastSelect)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(TabContent)
